import React from "react";

export default function TimeBlock({ times = [], ...props }) {
	function trimTime(string = "") {
		return string.replace(/:00$/, "");
	}
	return <div className="timeBlock" {...props}>
		<table>
			<tbody>
				{times.map(({ day, from, to }) => (
					<tr key={`${day}_${from}_${to}`}>
						<td className="text-left">{day}</td>
						<td className="text-right">{trimTime(from)}</td>
						{/* <td>&#10132;</td> */}
						<td className="text-right">{trimTime(to)}</td>
					</tr>
				))}
			</tbody>
		</table>
	</div>
}